import { Container } from 'inversify'
import { type Ref } from 'vue'
import { type RouteLocationNormalizedLoaded, useRouter } from 'vue-router'

import { createAxiosInstance } from '../../../_config/axios'
import { IApiProvider } from '../../../apiProviders/types/IApiProvider'
import { InterfaceType } from '../constants/InterfaceType'

export function bindConstants(container: Container): void {
  const router = useRouter()

  container
    .bind<IApiProvider>(InterfaceType.constants.ApiProvider)
    .toConstantValue(createAxiosInstance())
  container
    .bind<Ref<RouteLocationNormalizedLoaded>>(InterfaceType.constants.CurrentRoute)
    .toConstantValue(router.currentRoute)
}
